import { render, staticRenderFns } from "./Addquestion.vue?vue&type=template&id=2ec82fdb&scoped=true"
import script from "./Addquestion.vue?vue&type=script&lang=js"
export * from "./Addquestion.vue?vue&type=script&lang=js"
import style0 from "./Addquestion.vue?vue&type=style&index=0&id=2ec82fdb&prod&scoped=true&lang=css"
import style1 from "./Addquestion.vue?vue&type=style&index=1&id=2ec82fdb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec82fdb",
  null
  
)

export default component.exports